import { ClaimType } from "../enums";

export interface IClaimDeclineResponseItem {
    id: number,
    claimType: ClaimType,
    errorType: string,
    automatedMessage: string
}